var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPinterestMobileFlagLg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 10,
  viewBox: "0 0 10 10",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M1 0c.552 0 1 .456 1 .995v8.01c0 .51-.383.93-.883.988L1 10c-.552 0-1-.456-1-.995V.995c0-.51.383-.93.883-.988zm7.997.5C9.551.5 10 .951 10 1.49v4.02a.99.99 0 0 1-1.003.99H3v-6z"
})));
export default SvgPinterestMobileFlagLg;